import Vue from 'vue'
import Router from 'vue-router'
import $utils from '@/utils/utils';
import Cookies from "@/utils/cookie";
import { Message } from 'element-ui';
import { getInfo, getRouters, regionAll, dictDataList  } from '@/config/apiConfig/apiList.js';
import { routerMain } from '@/router/routerList.js'; // 邵阳路由
Vue.use(Router)


let routerData = routerMain; // 静态切换路由

// 基本静态路由
const routerStatic = [
  {
    path: '/',
    name: 'login',
    title: '登录',
    component: () => import('@/view/login/login'),
  },
]

let router = {};


// 获取用户信息
async function getUserInfoFun() { 
  const res1 = await getInfo();
  let userInfo = (res1 || {}).body.user;
  Vue.prototype.$userInfo = userInfo || {};
}

// 获取字典列表
async function getDictDataFun(){
  try {
    const res3 = await dictDataList({ pageNum: 1, pageSize: 10000 });
    let list = ((res3 || {}).body || {}).rows || [];
    console.log('获取字典列表', list);
    let dictData = {};
    list.forEach(item => {
      item.label = item.dictLabel;
      item.value = item.dictValue;
      if (dictData[item.dictType]) {
        dictData[item.dictType].push(item);
      } else {
        dictData[item.dictType] = [item];
      }
    })
    Vue.prototype.$dictData = dictData || [];
  } catch (e) {
    Vue.prototype.$dictData = [];
    console.log('获取字典列表失败', e)
  }
}

// 获取省市区列表
async function getRegionAllFun() {
  try {
    let regionList = window.sessionStorage.getItem('regionList');
    if (regionList) {
      regionList = JSON.parse(regionList);
    } else {
      const res5 = await regionAll();
      // const res5 = {}
      regionList = (res5 || {}).body || [];
      regionList = modifyChildren(regionList);
      window.sessionStorage.setItem('regionList', JSON.stringify(regionList));
    }
    Vue.prototype.$regionList = regionList || [];
  } catch (e) {
    Vue.prototype.$regionList = [];
    console.log('获取省市区列表失败', e)
  }
}


// 动态获取路由
async function addDynamicRoutes() {
  let routerList = [], userInfo = {};
  if (Cookies.getCookie('token')) {
    
    await getUserInfoFun(); // 获取用户信息
    await getDictDataFun(); // 获取字典列表
    await getRegionAllFun(); // 获取省市区列表

    // 获取动态路由列表
    const res2 = await getRouters();
    const routerChildren = [];
    let data2 = (res2 || {}).body || [];
    try {
      routerList = generateRoutesFromMenu(data2);
      Vue.prototype.$routerList = routerList;
      let activeRouter = window.sessionStorage.getItem('activeRouter');
      if (activeRouter && activeRouter != 'undefined' && activeRouter != 'null') {
        $utils.activeRouter = JSON.parse(activeRouter);
      } else {
        $utils.activeRouter = routerData[0];
        window.sessionStorage.setItem('activeRouter', JSON.stringify($utils.activeRouter));
      }
      routerList.map((item, index) => {
        item.children = item.children || [];
        routerChildren.push(...item.children)
      })
    } catch (e) { console.log('路由处理失败', e) }
    router = new Router({
      routes: [
        ...routerStatic,
        {
          path: '/home',
          name: 'home',
          component: () => import('@/view/home/home'),
          children: routerChildren
        }
      ]
    })
  } else {
    router = new Router({
      // mode: 'history',
      routes: [
        ...routerStatic,
        {
          path: '/home',
          name: 'home',
          component: () => import('@/view/home/home'),
          children: []
        }
      ]
    })
  }
  return { router };
}

// 不走动态路由
async function noRouter() {
  let s = 1;
  for (let i = 0; i < (routerData || []).length; i++) {
    let item1 = routerData[i] || {};
    item1.id = s = s + 1;
    for (let j = 0; j < (item1.children || []).length; j++) {
      let item2 = item1.children[j] || {};
      !item2.icon && (item2.icon = 'nav_icon110.png');
      item2.id = s = s + 1;
      for (let k = 0; k < (item2.children || []).length; k++) {
        let item3 = item2.children[k] || {};
        item3.id = s = s + 1;
      }
    }
  }
  // 获取静态路由列表
  Vue.prototype.$routerList = routerData;
  let activeRouter = window.sessionStorage.getItem('activeRouter');
  if (activeRouter && activeRouter != 'undefined' && activeRouter != 'null') {
    $utils.activeRouter = JSON.parse(activeRouter);
  } else {
    $utils.activeRouter = routerData[0];
    window.sessionStorage.setItem('activeRouter', JSON.stringify($utils.activeRouter));
  }
  const routerChildren = [];
  routerData.map((item, index) => {
    if ((item.children || []).length > 0) {
      routerChildren.push(...item.children)
    }
  })
  // console.log('routerChildren',routerChildren)
  router = new Router({
    // mode: 'history',
    routes: [
      ...routerStatic,
      {
        path: '/home',
        name: 'home',
        component: () => import('@/view/home/home'),
        children: routerChildren
      },
    ]
  })

  if (Cookies.getCookie('token')) {

    await getUserInfoFun(); // 获取用户信息
    await getDictDataFun(); // 获取字典列表
    await getRegionAllFun(); // 获取省市区列表

  }
  return { router };
}
let n = 0;
// 递归添加路由
function generateRoutesFromMenu(menu) {
  try {
    const routes = [];
    menu.forEach((item, index) => {
      item.meta.icon = (item.meta.icon || '').indexOf('.png') > -1 ? item.meta.icon : 'nav_icon110.png';
      n = n + 1;
      let route = {};
      if (item.component == '--' || !item.component) {
        route = {
          path: item.path || '/',
          title: item.meta.title,
          name: item.meta.title,
          icon: item.meta.icon || 'nav_icon110.png',
          activeIcon: item.meta.icon || 'nav_icon110.png',
          id: n + 1
        }
      } else if (item.component == '/' || !item.component) {
        route = {
          path: item.path || '/',
          title: item.meta.title,
          name: item.meta.title,
          icon: item.meta.icon || 'nav_icon110.png',
          activeIcon: item.meta.icon || 'nav_icon110.png',
          id: n + 1,
          // url: `@/view/main/main.vue`,
          component: () => import('@/view/main/main.vue'),
        }
      } else {
        route = {
          path: item.path || '/',
          title: item.meta.title,
          name: item.meta.title,
          icon: item.meta.icon || 'nav_icon110.png',
          activeIcon: item.meta.icon || 'nav_icon110.png',
          id: n + 1,
          // url: item.component == '/' ? '@/view/main/main.vue' : `@/view${item.component}.vue`,
          component: () => import(`@/view${item.component}.vue`),
        }
      }
      if (((item || {}).children || []).length > 0) {
        route.children = generateRoutesFromMenu(item.children)
      }
      routes.push(route)
    })
    return routes
  } catch (e) { console.log('路由处理失败', e) }

}

// 删除无子项
function modifyChildren(items) {
  return items.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      item.children = undefined;
    } else if (Array.isArray(item.children)) {
      item.children = modifyChildren(item.children); // 递归处理子项
    }
    return item;
  });
}



let routeFun = null;
// 开发环境
if (process.env.NODE_ENV === 'development') {
  routeFun = noRouter(); // 静态路由
  // routeFun = addDynamicRoutes(); // 动态路由

} else {
  routeFun = addDynamicRoutes(); // 动态路由
}

export default routeFun;


// WEBPACK FOOTER //
// ./src/router/index.js